export const authHeader = (token, contentType) => {
  const customHeaders = {
    Authorization: `Basic ${token}`,
    'Content-Type': contentType,
  };
  return customHeaders;
};
